export const SET_BLACKLIST_LOADING = 'SET_BLACKLIST_LOADING';
export const FETCH_BLACKLIST_SUCCESS = 'FETCH_BLACKLIST_SUCCESS';
export const EVICT_BLACKLIST_CACHE = 'EVICT_BLACKLIST_CACHE';
